module.exports = __webpack_public_path__ + "static/media/original.c4686a53.svg";